import { render } from "./BoqBuilderUnassigneds.vue?vue&type=template&id=23913c90&scoped=true"
import script from "./BoqBuilderUnassigneds.vue?vue&type=script&lang=js"
export * from "./BoqBuilderUnassigneds.vue?vue&type=script&lang=js"

import "./BoqBuilderUnassigneds.vue?vue&type=style&index=0&id=23913c90&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23913c90"]])

export default __exports__